import axios from '@axios'
import i18n from '@/libs/i18n'
import { storePagination } from '@/mixins/store'
import { sorting } from '@/mixins'
import managementAccountMaintain from './management-account-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  managementAccounts: [],
  dreClassifications: [],
  filters: {
    name: null,
    dreClassification: null,
    type: null,
    expenseType: null,
    active: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  modules: { managementAccountMaintain },

  getters: {
    dreClassificationsOptions(state) {
      return state.dreClassifications?.map(item => ({
        ...item,
        value: item.id,
        label: item.name
      }))
    },
    accountTypes() {
      return [
        { value: 'Input', label: i18n.t('Entrada') },
        { value: 'Output', label: i18n.t('Saída') },
      ]
    },
    expenseTypes() {
      return [
        { value: 'Fixed', label: i18n.t('Fixa') },
        { value: 'Variable', label: i18n.t('Variável') },
      ]
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_MANAGEMENT_ACCOUNTS(state, managementAccounts) {
      state.managementAccounts = managementAccounts
    },
    SET_DRE_CLASSIFICATIONS(state, dreClassifications) {
      state.dreClassifications = dreClassifications
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, managementAccounts } = getInitialState()
      state.filters = filters
      state.managementAccounts = managementAccounts
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchDreClassifications({ commit }) {
      const { data } = await axios.get('/api/accounting/dre-classifications', {
        params: {
          pageSize: 999,
        }
      })
      commit('SET_DRE_CLASSIFICATIONS', data.results)
    },

    async fetchManagementAccounts({ commit, state }) {
      const { data } = await axios.get('/api/accounting/management-accounts', {
        params: {
          name: state.filters.name,
          dreClassificationId: state.filters.dreClassification,
          type: state.filters.type,
          expenseType: state.filters.expenseType,
          active: state.filters.active,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })
      commit('SET_MANAGEMENT_ACCOUNTS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
